import { Cell } from '@/design_system/Table/Table';
import { ShipmentWithRelations } from '@/models/shipment';
import { ShipmentStepDueDate } from '@/routes/Shipments/Tabs/components/ShipmentStepDueDate';

export const ShipmentStepDueDateCell = ({ shipment }: { shipment: ShipmentWithRelations }) => {
  return (
    <Cell>
      <ShipmentStepDueDate shipment={shipment} variant="row" />
    </Cell>
  );
};
